import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MENYU_ACARLAR, ayarOxu, ayarYaz } from '../utils/menyuAyarlari';
import './MenuSetup.css';

/* Menyu quraşdırması — yan panelin görünüşü bu səhifədən idarə olunur.
   Ayarlar serverə yazılmır: hər istifadəçinin öz brauzerinin seçimidir,
   ona görə başqa kompüterdə açanda yenidən seçmək lazım gələcək. */

const TEMALAR = [
  { ad: 'firuzeyi',  reng: '#0f3a3f', vurgu: '#5eead4' },
  { ad: 'gece',      reng: '#1c2750', vurgu: '#93c5fd' },
  { ad: 'sherab',    reng: '#411a33', vurgu: '#fcd34d' },
  { ad: 'mese',      reng: '#174227', vurgu: '#86efac' },
  { ad: 'komur',     reng: '#2d3137', vurgu: '#fbbf24' },
  { ad: 'benovseyi', reng: '#322563', vurgu: '#c4b5fd' },
  { ad: 'buz',       reng: '#cfeaf3', vurgu: '#0e7490' },
  { ad: 'sedef',     reng: '#f2e7e2', vurgu: '#b45309' },
];

const NAXISLAR = [
  { ad: 'yox',   acar: 'patternNone' },
  { ad: 'tor',   acar: 'patternGrid' },
  { ad: 'noqte', acar: 'patternDots' },
];

export default function MenuSetup() {
  const { t } = useLanguage();

  const [tema, setTema] = useState(() => ayarOxu(MENYU_ACARLAR.tema, 'firuzeyi'));
  const [naxis, setNaxis] = useState(() => ayarOxu(MENYU_ACARLAR.naxis, 'yox'));
  const [gorunus, setGorunus] = useState(() => ayarOxu(MENYU_ACARLAR.gorunus, 'siyahi'));

  const sec = (acar, deyer, setter) => { setter(deyer); ayarYaz(acar, deyer); };

  const berpaEt = () => {
    sec(MENYU_ACARLAR.tema, 'firuzeyi', setTema);
    sec(MENYU_ACARLAR.naxis, 'yox', setNaxis);
    sec(MENYU_ACARLAR.gorunus, 'siyahi', setGorunus);
  };

  const cariTema = TEMALAR.find(x => x.ad === tema) || TEMALAR[0];

  return (
    <div className="ms-page">
      <div className="ms-header">
        <div>
          <h2>{t('menuSetup.title')}</h2>
          <p>{t('menuSetup.subtitle')}</p>
        </div>
        <button type="button" className="ms-reset" onClick={berpaEt}>
          {t('menuSetup.reset')}
        </button>
      </div>

      {/* 1. Rəng çaları */}
      <section className="ms-blok">
        <div className="ms-blok-bas">
          <span className="ms-no">01</span>
          <div>
            <h3>{t('menuSetup.colorTitle')}</h3>
            <p>{t('menuSetup.colorHint')}</p>
          </div>
          <span className="ms-cari">{t('sidebar.theme_' + cariTema.ad)}</span>
        </div>
        <div className="ms-temalar" role="listbox" aria-label={t('menuSetup.colorTitle')}>
          {TEMALAR.map(x => (
            <button key={x.ad} type="button" role="option"
                    aria-selected={tema === x.ad}
                    className={'ms-tema' + (tema === x.ad ? ' on' : '')}
                    onClick={() => sec(MENYU_ACARLAR.tema, x.ad, setTema)}>
              <span className="ms-tema-numune"
                    style={{ background: `linear-gradient(160deg, ${x.reng} 55%, ${x.vurgu} 160%)` }}>
                <span className="ms-tema-xett" style={{ background: x.vurgu }} />
                <span className="ms-tema-xett kicik" style={{ background: x.vurgu }} />
              </span>
              <span className="ms-tema-ad">{t('sidebar.theme_' + x.ad)}</span>
            </button>
          ))}
        </div>
      </section>

      {/* 2. Fon naxışı */}
      <section className="ms-blok">
        <div className="ms-blok-bas">
          <span className="ms-no">02</span>
          <div>
            <h3>{t('menuSetup.patternTitle')}</h3>
            <p>{t('menuSetup.patternHint')}</p>
          </div>
        </div>
        <div className="ms-secimler" role="listbox" aria-label={t('menuSetup.patternTitle')}>
          {NAXISLAR.map(x => (
            <button key={x.ad} type="button" role="option"
                    aria-selected={naxis === x.ad}
                    className={'ms-secim' + (naxis === x.ad ? ' on' : '')}
                    onClick={() => sec(MENYU_ACARLAR.naxis, x.ad, setNaxis)}>
              <span className={'ms-naxis-numune naxis-' + x.ad}
                    style={{ background: cariTema.reng }} />
              <span className="ms-secim-ad">{t('sidebar.' + x.acar)}</span>
            </button>
          ))}
        </div>
      </section>

      {/* 3. Menyunun quruluşu */}
      <section className="ms-blok">
        <div className="ms-blok-bas">
          <span className="ms-no">03</span>
          <div>
            <h3>{t('menuSetup.layoutTitle')}</h3>
            <p>{t('menuSetup.layoutHint')}</p>
          </div>
        </div>
        <div className="ms-secimler" role="radiogroup" aria-label={t('menuSetup.layoutTitle')}>
          <button type="button" role="radio" aria-checked={gorunus === 'siyahi'}
                  className={'ms-secim' + (gorunus === 'siyahi' ? ' on' : '')}
                  onClick={() => sec(MENYU_ACARLAR.gorunus, 'siyahi', setGorunus)}>
            <span className="ms-quruluş-numune" style={{ background: cariTema.reng }}>
              {[0, 1, 2, 3].map(i => (
                <span key={i} className="msq-setir">
                  <span className="msq-ikon" style={{ background: cariTema.vurgu }} />
                  <span className="msq-mtn" />
                </span>
              ))}
            </span>
            <span className="ms-secim-ad">{t('sidebar.viewList')}</span>
          </button>
          <button type="button" role="radio" aria-checked={gorunus === 'setka'}
                  className={'ms-secim' + (gorunus === 'setka' ? ' on' : '')}
                  onClick={() => sec(MENYU_ACARLAR.gorunus, 'setka', setGorunus)}>
            <span className="ms-quruluş-numune setka" style={{ background: cariTema.reng }}>
              {[0, 1, 2, 3].map(i => (
                <span key={i} className="msq-xana">
                  <span className="msq-ikon" style={{ background: cariTema.vurgu }} />
                  <span className="msq-mtn" />
                </span>
              ))}
            </span>
            <span className="ms-secim-ad">{t('sidebar.viewGrid')}</span>
          </button>
        </div>
      </section>

      <p className="ms-qeyd">{t('menuSetup.note')}</p>
    </div>
  );
}
